// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import lightbox
import './ekko-lightbox.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//HAMBURGER BUTTON
$('.nav-mobile-button').on('click', function () {
  if ($('.hamburger-container').hasClass('change') && $('.navbar-collapse').hasClass('show')) {
    $('.hamburger-container').removeClass('change');
  }
  else if ($('.navbar-collapse').hasClass('collapse') && !$('.navbar-collapse').hasClass('show')) {
    $('.hamburger-container').addClass('change');
  }
  //$('.hamburger-container').toggleClass('change');
})

//NAVWALKER DROPDOWN BUTTON
$('.mobile-dropdown-button').on('click', function () {
  $(this).toggleClass('dropdown-button-change');
  $(this).siblings('.dropdown-menu').toggleClass('dropdown-change');
})

$('#menu-valikko .menu-item-has-children').append('<span class="sub-menu-button"></span>');

$('.sub-menu-button').on('click', function() {
  $(this).toggleClass('dropdown-button-change');
  $(this).siblings('.sub-menu').slideToggle();
})

$('.mobile-menu-close, .hamburger-container, .mobile-menu-container, .bar1, .bar2, .bar3').on('click', function (e) {
  if (e.target == this) {
    $('.mobile-menu-container').fadeToggle();
  } 
})

$('a[href]').filter(function() {
  return /(jpg|gif|png)$/.test( $(this).attr('href'))
}).attr({'data-toggle': 'lightbox', 'data-gallery': 'gallery'});

$(document).on('click', '[data-toggle="lightbox"], .widget_media_image a', function(event) {
  event.preventDefault();
  $(this).ekkoLightbox({
    alwaysShowClose: true,
  });
});

$('.paa-dropdown-item-title').on('click', function() {
  $(this).siblings('.paa-dropdown-item-content').slideToggle();
  $(this).toggleClass('open');
})


// WEBPACK FOOTER //
// ./scripts/main.js